var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.359,
    height: 21.493,
    viewBox: "0 0 28.359 21.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discord-logo-blue",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8806",
    "data-name": "Path 8806",
    d: "M24.022,1.8A23.454,23.454,0,0,0,18.172,0a16.073,16.073,0,0,0-.749,1.523,21.787,21.787,0,0,0-6.493,0A16.141,16.141,0,0,0,10.18,0,23.619,23.619,0,0,0,4.325,1.8a23.638,23.638,0,0,0-4.2,16.086h0a23.583,23.583,0,0,0,7.175,3.6,17.331,17.331,0,0,0,1.537-2.478,15.261,15.261,0,0,1-2.42-1.155c.2-.147.4-.3.593-.446a16.856,16.856,0,0,0,14.347,0c.194.158.393.31.593.446a15.32,15.32,0,0,1-2.425,1.158,17.175,17.175,0,0,0,1.537,2.476,23.476,23.476,0,0,0,7.18-3.6h0A23.624,23.624,0,0,0,24.022,1.8ZM9.469,14.652a2.712,2.712,0,0,1-2.554-2.83A2.7,2.7,0,0,1,9.464,8.98a2.685,2.685,0,0,1,2.556,2.842A2.709,2.709,0,0,1,9.469,14.652Zm9.422,0a2.709,2.709,0,0,1-2.552-2.83A2.7,2.7,0,0,1,18.89,8.98a2.678,2.678,0,0,1,2.549,2.842A2.707,2.707,0,0,1,18.89,14.652Z",
    transform: "translate(0)",
    fill: "#5865f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.3a829225f984eb3305f521fcccca9fe3.svg";
export { ForwardRef as ReactComponent };